export const links = {
  start: "/",
  login: "/login",
  reg: "/reg",
  stories: "/stories",
  profile: "/profile",
  profileInfo: "/profile/info",
  step: "/step",
  policy: "/policy",
  rules: "/rules",
  recoveryPassword: "/recovery-password",
  feedback: "/feedback",
  instruction: "/instruction",
};
